import { useCurrentWorkspace } from '@/context/current-workspace';
import { AccountFeatureFlag, hasFeatureFlag } from '@/services/auth/feature-flags';
import { useSampleWorkspace } from '@/features/workspaces/sample-workspace';
import { Strong, Text } from '@customerio/pluma-components/react';
import * as styles from './index.css';

/**
 * Sample workspace components that show visual indicators when viewing the sample workspace
 */

export function SampleWorkspaceBadge() {
  const workspace = useCurrentWorkspace();
  const { isSampleWorkspace } = useSampleWorkspace();

  if (
    !(hasFeatureFlag(AccountFeatureFlag.InteractiveDemoWorkspace) || hasFeatureFlag(AccountFeatureFlag.SampleWorkspace))
  ) {
    return null;
  }

  if (!isSampleWorkspace(workspace?.id)) {
    return null;
  }

  return (
    <div>
      <div className={styles.sampleWorkspaceBadge}>
        <Text color="inherit">
          You're currently viewing the <Strong>Sample Workspace.</Strong> Switch to{' '}
          {/* Using a Text component to force a refresh when switching to the sample workspace.
          Can be replaced with a PlainLink once we can reliably get the last user workspace id. */}
          <Text as="a" href="/" textDecoration="underline">
            my workspace
          </Text>
          .
        </Text>
      </div>
    </div>
  );
}

/**
 * Sample workspace border that shows a border around the entire page when the user
 * is viewing the sample workspace.
 */
export function SampleWorkspaceBorder() {
  const workspace = useCurrentWorkspace();
  const { isSampleWorkspace } = useSampleWorkspace();

  if (
    !(hasFeatureFlag(AccountFeatureFlag.InteractiveDemoWorkspace) || hasFeatureFlag(AccountFeatureFlag.SampleWorkspace))
  ) {
    return null;
  }

  if (!isSampleWorkspace(workspace?.id)) {
    return null;
  }

  return <div className={styles.sampleWorkspaceBorder} />;
}
